<template>
  <!--        选择框模式-->
  <el-cascader
          v-if="type === 'select'"
          ref="EL_CASCADER_DOM"
          :clearable="clearable"
          class="j-grid-wrap"
          v-model="gridArr"
          :options="treeData"
          :props="{ label: 'value', value: 'key', ...props, multiple }"
          v-bind="$attrs"
          @change="JGridCtrlEvent" />
  <!--        文本模式-->
  <span v-else class="j-grid-text">
      <template v-if="multiple">
        {{String(value).split(',').map(item => getGridNameByGridCode(item, textSeparator ,rule)).join(',')}}
      </template>
      <template v-else>
        {{getGridNameByGridCode(value, textSeparator ,rule)}}
      </template>
    </span>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import JGridCtrlMixins from './mixins'

  export default {
    name: 'JGridCtrl',
    inheritAttrs: false, // $attrs 继承的属性会在组件根容器节点上展示,
    mixins: [JGridCtrlMixins],
    props: {
      props: {
        type: Object,
        default: () => {
          return { checkStrictly: true }
        }
      },
      onlyChild: { // 当指定rangeCode解析时，是否仅仅显示子集（不包含自身层级）
        type: Boolean,
        default: false
      },
      multiple: { //  是否多选
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: true
      },
      rangeCode: { // 根据传递的编码，仅获取编码下级
        type: [Number, String],
        default: ''
      },
      value: {
        // 可传数字或文本类型的网格编号
        type: [Number, String]
      },
      rule: {
        // 网格号分割规则 (规则 4:市，6:区/县，9：街道，12：社区，14：网格)
        type: Array,
        default: () => [6, 9, 12, 14]
      },
      textSeparator: {
        // 文本模式分隔符
        type: String,
        default: '-'
      },
      type: {
        // select为选择框模式，text或不传未文本解析模式
        type: String,
        default: 'text'
      }
    },
    computed: {
      ...mapState('JGridCtrl', {
        gridMap: state => state.gridMap,
        gridTree: state => state.gridTree,
        gridDivide: state => state.gridDivide
      })
    },
    data() {
      return {
        gridArr: [],
        treeData: [],
        rangeCodeIndex: '' // 限定范围时需要忽略修正rule的最小解析长度
      }
    },
    watch: {
      value (nv) {
        if (!nv && nv !== 0) {
          this.gridArr = []
        }
        this.updateData()
      },
      gridTree: {
        handler() {
          this.handleTree()
        },
        deep: true
      },
      rule: {
        handler() {
          this.$refs['EL_CASCADER_DOM'] && (this.$refs['EL_CASCADER_DOM'].panel.activePath = []) // 面板在更换数据源时，需要已展开的数据
          this.handleTree()
        },
        deep: true
      }
    },
    methods: {
      ...mapActions('JGridCtrl', ['getGridMap']),
      handleTree () {
        if (this.type !== 'select') return // 仅在选择模式下计算
        const length = this.rule.length
        if (this.rangeCode) { // 如果有指定code 合并rule
          this.rangeCodeIndex = String(this.rangeCode).length
          let lastRule = this.rule[length - 1] || this.rangeCodeIndex
          let array = []
          if (this.rangeCodeIndex < lastRule) {
             this.getRecursiveByDeepSearchCode(this.gridTree, array, this.rangeCode, lastRule, this.onlyChild)
             if (lastRule < 14) this.getRecursiveByDeepRemoveChild(array, lastRule)
          } else array = [{ key: this.rangeCode, value: this.gridMap[this.rangeCode] }]
          this.treeData = array
          return
        }
        if (length < 1) return (this.treeData = this.gridTree)
        const fi = this.rule[0]
        const li = this.rule[length - 1]
        if (fi == 4 && li == 14) (this.treeData = this.gridTree)
        else if (fi === li) (this.treeData = this.gridDivide[fi])
        else if (li == 14) {
          const array = []
          this.getRecursiveByDeepRemoveParent(this.gridTree, array, fi)
          this.treeData = array
        } else {
          const array = []
          this.getRecursiveByDeepRemoveParent(this.gridTree, array, fi)
          this.getRecursiveByDeepRemoveChild(array, li)
          this.treeData = array
        }
      },
      updateData () {
        if (this.multiple && this.value && this.type === 'select') {
          this.gridArr = []
          const gridCodeArr = String(this.value).split(',')
          let rule = this.ruleHandle(this.rangeCodeIndex || this.rule[0] || '', this.rule[this.rule.length - 1]) // 生成规范rule解析
          gridCodeArr.forEach(gridCode => {
            const tempArr = []
            rule.forEach(n => {
              if (gridCode.length >= n) {
                tempArr.push(gridCode.substr(0, n))
              }
            })
            this.gridArr.push(tempArr)
          })
        } else if (this.value && this.type === 'select') {
          this.gridArr = []
          const gridCode = String(this.value)
          let rule = this.ruleHandle(this.rangeCodeIndex || this.rule[0] || '', this.rule[this.rule.length - 1]) // 生成规范rule解析
          rule.forEach(n => {
            if (gridCode.length >= n) {
              this.gridArr.push(gridCode.substr(0, n))
            }
          })
        }
      },
      ruleHandle (start, end) {
          if (start === '') return []
          if (start >= end) return [start]
          const ruleArr = [4,6,9,12,14]
          let si = ruleArr.indexOf(start)
          let ei = ruleArr.indexOf(end)
          const rule = []
          ruleArr.forEach((item, i) => {
              if (i >= si  && i <= ei) rule.push(item)
          })
          return rule
      },
      JGridCtrlEvent(Arr) {
        if (this.multiple) {
          const tempCodeArr = []
          const pathArr = []
          Arr.forEach(codeArr => {
            tempCodeArr.push(codeArr[codeArr.length - 1] || '')
            const TempPath = []
            codeArr.forEach(key => {
              TempPath.push(this.gridMap[key] || '解析异常')
            })
            pathArr.push(TempPath)
          })
          const code = tempCodeArr.join(',')
          this.$emit('input', code)
          this.$emit('change', {
            code,
            codeArr: [...Arr],
            pathArr
          })
        } else {
          this.$emit('input', Arr[Arr.length - 1] || '')
          const path = []
          Arr.forEach(key => {
            path.push(this.gridMap[key] || '解析异常')
          })
          this.$emit('change', {
            code: Arr[Arr.length - 1] || '',
            codeArr: [...Arr],
            pathArr: [...path]
          })
        }
      }
    },
    created() {
      this.handleTree()
      this.updateData()
      this.getGridMap()
    }
  }
</script>

<style>
  .j-grid-wrap {
    width: 100%;
  }
  .j-grid-text:empty::before {
    content: '-';
    font-weight: lighter;
    color: #c0c4cc;
  }
</style>
